<template>
    <div :class="{ 'error-border': errorBorder }">
        <label v-if="label">{{ label }}</label>
        <editor
            key="default"
            :value="value"
            :init="initEditorSettings"
            :tinymce-script-src="tinyMceScript"
            @input="$emit('input', $event)"
        />
    </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import config from '@/config';

export default {
    components: {
        Editor
    },

    props: {
        value: {
            required: false,
            default: '',
            type: String
        },
        label: {
            required: false,
            default: '',
            type: String
        },
        errorBorder: {
            required: false,
            default: false,
            type: Boolean
        }
    },

    computed: {
        tinyMceScript() {
            return `${config.publicPath}js/tinymce/tinymce.min.js`;
        },

        initEditorSettings() {
            return {
                height: 400,
                menubar: 'file edit view format insert tools table help',
                plugins: [
                    'code',
                    'advlist',
                    'autolink',
                    'lists',
                    'link',
                    'image',
                    'charmap',
                    'preview',
                    'anchor',
                    'searchreplace',
                    'visualblocks',
                    'code',
                    'fullscreen',
                    'insertdatetime',
                    'media',
                    'table',
                    'code',
                    'help',
                    'emoticons',
                    'wordcount',
                    'directionality'
                ],
                toolbar: `undo redo preview | styles code | emoticons anchor blockquote forecolor backcolor bold italic ltr rtl bullist numlist | alignleft aligncenter alignright alignjustify |
                ' outdent indent | link image | print preview media fullscreen |
                ' removeformat | help`,
                fontsize_formats:
                    '8px 9px 10px 11px 12px 14px 18px 24px 30px 36px 48px 60px 72px 96px',
                directionality: 'rtl',
                table_appearance_options: false,
                relative_urls: false,
                paste_as_text: true
            };
        }
    }
};
</script>
